// extracted by mini-css-extract-plugin
export default {"priceComponent":"orderPrice_priceComponent__VLNYM","products":"orderPrice_products__mQThj","total":"orderPrice_total__1p0wn"};